import { useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { useAppDispatch } from '../../../../../App/Hooks/reduxHooks'
import { Flex } from '../../../../../Common/Flex'
import { H3, Text } from '../../../../../Common/Typography'
import { useDeleteAbsenceMutation } from '../../../../AbsenceNew/util/useAbsenceQuery'
import { useDeleteGeneralAbsenceMutation } from '../../../../GeneralAbsence/util/useGeneralAbsenceQuery'

import { Overlay, RemoveButtonIcon, StyledButton } from './style'

type Props = {
  absenceUuid: string
  setIsOverlayActive: (state: false) => void
  type: 'absence' | 'general-absence'
  isInactiveCrudButtons: boolean
}

export const DeleteOverlay = ({
  absenceUuid,
  setIsOverlayActive,
  type,
  isInactiveCrudButtons,
}: Props) => {
  const history = useHistory()
  const queryClient = useQueryClient()
  const absenceMutation = useDeleteAbsenceMutation(queryClient)
  const generalAbsenceMutation = useDeleteGeneralAbsenceMutation(queryClient)

  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const handleDelete = () => {
    if (absenceMutation.isSuccess || generalAbsenceMutation.isSuccess) {
      alert('delete success')
    }
    // dispatch(
    //   addError({
    //     type: 'info',
    //     title: t('General absence removed.'),
    //     icon: 'info-circle',
    //     duration: 'short'
    //   }),
    // )
    type === 'absence'
      ? absenceMutation.mutate(absenceUuid)
      : generalAbsenceMutation.mutate(absenceUuid)
  }

  if (isInactiveCrudButtons) {
    return (
      <Overlay>
        <Flex
          justifyContent={'center'}
          alignItems={'center'}
          flexDirection={'column'}>
          <Flex flexDirection={'column'} alignItems={'center'}>
            <H3 mb={2} color={'lights.4'} marginBottom={0}>
              {t('You want to change a general-absence')}.
            </H3>
            <Text pl={3} pr={3}>
              {t(
                'By clicking the redirect button you will be brought to the page where you can update general-absences',
              )}
              ?
            </Text>
          </Flex>
          <Flex>
            <StyledButton
              size={'small'}
              variant={{ type: 'filled' }}
              onClick={() => history.push(`/hr/general-absences`)}>
              {t('Redirect')}
            </StyledButton>
            <StyledButton
              size={'small'}
              variant={{ type: 'filled' }}
              onClick={() => setIsOverlayActive(false)}>
              <RemoveButtonIcon icon={'trash-undo'} />
              {t('Cancel')}
            </StyledButton>
          </Flex>
        </Flex>
      </Overlay>
    )
  }

  return (
    <Overlay>
      <Flex
        justifyContent={'center'}
        alignItems={'center'}
        flexDirection={'column'}>
        <Flex flexDirection={'column'} alignItems={'center'}>
          <H3 mb={2} color={'lights.4'} marginBottom={0}>
            {t('You are about to delete an absence')}.
          </H3>
          <Text>{t('Are you sure you want to proceed')}?</Text>
        </Flex>
        <Flex>
          <StyledButton
            size={'small'}
            variant={{ type: 'filled' }}
            onClick={() => handleDelete()}>
            {t('Yes')}
          </StyledButton>
          <StyledButton
            size={'small'}
            variant={{ type: 'filled' }}
            onClick={() => setIsOverlayActive(false)}>
            <RemoveButtonIcon icon={'trash-undo'} />
            {t('Cancel')}
          </StyledButton>
        </Flex>
      </Flex>
    </Overlay>
  )
}
